// extracted by mini-css-extract-plugin
export default {"casilla":"PoliticaCheckbox_casilla__Kgzpg"};